// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { policiesModel } from '@/firebase/firebase-config'

export const GetPolicy = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        policy: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getPolicyHandler: async function() {

            try {

                // Get the user doc
                policiesModel.where('attributes.slug', '==', this.$route.params.slug).get()
                .then(snapshot => {

                    if (snapshot.empty) {

                        /*
                        **  Send to 404 not found
                        */

                        this.$router.push({ name: 'NotFound' });

                    }

                    /*
                    **  Loop through the results and set the document
                    */

                    snapshot.forEach(doc => {

                        /*
                        **  Set the article prop
                        **  @prop_location: @here
                        */

                        this.policy = doc.data();

                    });
                    

                })
                .catch(error => {

                    /*
                    **  Send to 404 not found
                    **  @service: Router
                    */

                    this.$router.push({ name: 'NotFound' });

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportNoAuthBugsnagError({
                        title: 'Get Policy Document from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Policies',
                        uid: 'X6WSaDdDNxz1cmh4jUD7',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to 404 not found
                **  @service: Router
                */

                this.$router.push({ name: 'NotFound' });

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportNoAuthBugsnagError({
                    title: 'Get Policy Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Policies',
                    uid: '3nvLOm6llfW9lcFOcpXZ',
                    error: e
                });

            }

        }

    }

}